import { FieldMetaProps } from "formik"
import { TFunction } from "i18next"

export const requiredError = "Required"

export const getRequiredMessage = (
  t: TFunction,
  meta: FieldMetaProps<any>,
  isRequired?: boolean,
): string | undefined =>
  isRequired && meta.touched && meta.error === requiredError
    ? t("popup.Default.Form.RequiredField")
    : undefined
